import React from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/joy';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import FolderIcon from '@mui/icons-material/Folder';
import FileCard from './FileCard';

const FileGrid = ({
  items,
  loading,
  isSelected,
  onSelect,
  onOpen,
  onContextMenu,
  renamingId,
  onRenameSubmit,
  onRenameCancel,
  dropTargetId,
}) => {
  if (loading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ py: 8 }}>
        <CircularProgress size="lg" />
        <Typography level="body-sm" color="neutral" sx={{ mt: 2 }}>
          Loading files...
        </Typography>
      </Stack>
    );
  }

  if (!loading && items.length === 0) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{
          py: 8,
          border: '2px dashed',
          borderColor: 'neutral.300',
          borderRadius: 'lg',
          bgcolor: 'background.level1',
        }}
      >
        <FolderIcon sx={{ fontSize: 80, color: 'neutral.300' }} />
        <Typography level="h4" color="neutral" sx={{ mt: 2 }}>
          This folder is empty
        </Typography>
        <Typography level="body-sm" color="neutral" sx={{ mt: 1 }}>
          Drop files here or click Upload to get started
        </Typography>
      </Stack>
    );
  }

  return (
    <Droppable droppableId="storage-grid" type="STORAGE_ITEM" direction="horizontal">
      {(provided, snapshot) => (
        <Box
          ref={provided.innerRef}
          {...provided.droppableProps}
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
            gap: 2,
            p: 1,
            minHeight: 200,
            borderRadius: 'md',
            transition: 'background-color 0.2s',
            bgcolor: snapshot.isDraggingOver ? 'primary.50' : 'transparent',
          }}
        >
          {items.map((item, index) => (
            <Draggable key={item.path} draggableId={item.path} index={index}>
              {(dragProvided, dragSnapshot) => (
                <FileCard
                  item={item}
                  isSelected={isSelected(item.path)}
                  onSelect={onSelect}
                  onOpen={onOpen}
                  onContextMenu={onContextMenu}
                  isRenaming={renamingId === item.path}
                  onRenameSubmit={(newName) => onRenameSubmit(item.path, newName)}
                  onRenameCancel={onRenameCancel}
                  isDragging={dragSnapshot.isDragging}
                  isDropTarget={dropTargetId === item.path && item.type === 'folder'}
                  dragHandleProps={dragProvided.dragHandleProps}
                  draggableProps={dragProvided.draggableProps}
                  innerRef={dragProvided.innerRef}
                />
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </Box>
      )}
    </Droppable>
  );
};

export default FileGrid;
